import { render, staticRenderFns } from "./sifan.vue?vue&type=template&id=08191d00&scoped=true"
import script from "./sifan.vue?vue&type=script&lang=js"
export * from "./sifan.vue?vue&type=script&lang=js"
import style0 from "./sifan.vue?vue&type=style&index=0&id=08191d00&prod&lang=scss&scoped=true"
import style1 from "./sifan.vue?vue&type=style&index=1&id=08191d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08191d00",
  null
  
)

export default component.exports